import React from 'react'
import ReactPlayer from 'react-player'
import ImageZoom from 'react-medium-image-zoom'

const MarleySpoon = () =>
  <div>
  <section className="container">
    <div className="client-quote">
      <blockquote>
        Marley Spoon is a Berlin based startup that delivers recipe boxes with innovative recipes and high quality ingredients, bringing the cooking experience back to your kitchen.
      </blockquote>
    </div>
  </section>

    <section className="container">
        <div className="col-12-of-12">
          {/* <ImageZoom
            image={{
              src: require('img/marleyspoon/marleyspoon-image-4.png'),
              alt: 'MarleySpoon',
            }}
          /> */}
          <img src={require('img/marleyspoon/marleyspoon-image-4.png')} alt="MarleySpoon Phones" />
        </div>
    </section>
    <section className="container full">
      <div className="col-12-of-12">
        <img src={require('img/marleyspoon/marleyspoon-image-1.png')} alt="MarleySpoon Phones" />
      </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          Our collaboration with this project was at a really early stage, and we took care of building up the design base for this project, working the brand identity, stationery, packaging, and moving towards UI related work for the web platform and the iPhone app.
        </blockquote>
      </div>
    </section>
    <section className="container full">
      <div className="col-12-of-12">
        <img src={require('img/marleyspoon/marleyspoon-image-3.png')} alt="MarleySpoon Phones" />
      </div>
    </section>
    <br/><br/><br/><br/>
    <section className="container">
      <div className="fullwidth-video-wrapper">
        {/* <video src="https://www.youtube.com/watch?v=-1sX-giVzeE" loop muted autoPlay className="fullwidth-video" /> */}
        <ReactPlayer
          url="https://www.youtube.com/embed/NGxzaqWFfhQ"
          className="video-player"
          width="100%"
          height="100%"
          playing={false}
          playbackRate={1}
          loop={false}
          // volume={0}
          controls={true}
          // youtubeConfig={{ attributes: { preload: true } }}
          // TODO Add custom posters for videos (to be also used as fallback images) 👇 This is supposed to work: https://github.com/CookPete/react-player/issues/62
          fileConfig={{ attributes: { poster: 'https://placehold.it/100x100/' } }}
        />
      </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          Our collaboration with this project was at a really early stage, and we took care of building up the design base for this project, working the brand identity, stationery, packaging, and moving towards UI related work for the web platform and the iPhone app.
        </blockquote>
      </div>
    </section>
  </div>

export default MarleySpoon



// WEBPACK FOOTER //
// src/javascripts/clients/MarleySpoon.js